export default {"src":"/_next/static/media/moving-mountains.e1e4594a.svg","height":93,"width":116,"blurWidth":0,"blurHeight":0};